import { Part, partProps } from '@/Engine/Wardrobe/Part';
import { defaultShelfBracketOffsets, defaultShelfBracketRotation } from '@/Constants/shelfBrackets';

export interface iShelfBracketProps extends partProps {
    isLeft?: boolean;
    isRight?: boolean;
}

export class ShelfBrackets extends Part {
    isLeft = false;
    isRight = false;

    constructor(props: iShelfBracketProps) {
        super({ offsets: [ ...defaultShelfBracketOffsets ], rotation: [ ...defaultShelfBracketRotation ], ...props });
        if (props.isLeft) {
            this.isLeft = true;
            this.isRight = false;
        }
        if (props.isRight) {
            this.isLeft = false;
            this.isRight = true;
        }
    }

}
